// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".success-aa1{background:#f6fff6;border:1px solid #caefdc}.error-aa1 .el-message__content{color:red!important}", ""]);
// Exports
module.exports = exports;
